import { useEffect, useState } from 'react';
import { readCareerContent } from '../services/careerCatalogueApi';
import { getCompanyFromUrl } from '../utils/company';

export function useCareerContent<T>(path: string) {
  const [content, setContent] = useState<T | null>(null);
  const [error, setError] = useState(false);
  const [attempt, setAttempt] = useState(0);
  const company = getCompanyFromUrl();
  useEffect(() => {
    const controller = new AbortController();
    readCareerContent<T>(path, controller.signal).then(value => {
      if (!controller.signal.aborted) { setContent(value); setError(false); }
    }).catch(() => { if (!controller.signal.aborted) setError(true); });
    return () => controller.abort();
  }, [path, company, attempt]);
  return { content, error, retry: () => { setError(false); setAttempt(value => value + 1); } };
}
